"use client";

import dynamic from "next/dynamic";
import type {
  LineChartDataPoint,
  PieChartDataPoint,
} from "@/components/calculator/ChartWrapper";

const ChartSkeleton = () => (
  <div className="h-[300px] animate-pulse rounded-lg bg-muted" />
);

export const AreaChartWrapper = dynamic(
  () =>
    import("@/components/calculator/ChartWrapper").then((m) => ({
      default: m.AreaChartWrapper,
    })),
  { ssr: true, loading: () => <ChartSkeleton /> }
);

export const PieChartWrapper = dynamic(
  () =>
    import("@/components/calculator/ChartWrapper").then((m) => ({
      default: m.PieChartWrapper,
    })),
  { ssr: true, loading: () => <ChartSkeleton /> }
);

export const LineChartWrapper = dynamic(
  () =>
    import("@/components/calculator/ChartWrapper").then((m) => ({
      default: m.LineChartWrapper,
    })),
  { ssr: true, loading: () => <ChartSkeleton /> }
);

export const AreaChartDualAxis = dynamic(
  () =>
    import("@/components/calculator/ChartWrapper").then((m) => ({
      default: m.AreaChartDualAxis,
    })),
  { ssr: true, loading: () => <ChartSkeleton /> }
);

export type { LineChartDataPoint, PieChartDataPoint };
